import React from 'react';
import fot from '../assets/images/team/fot.avif';
import mga from '../assets/images/team/mga.png';
import jca from '../assets/images/team/jap.jpeg';
import yv from '../assets/images/team/yvi.jpeg';
const Team = () => {
  const founders = [
    {
      name: 'Fernando Oteros',
      role: 'CEO & Co-founder',
      photo: fot, // Ruta a la foto
      bio: '19 años de experiencia en IA y desarrollo de software. Dirigiendo equipos en consultoras de desarrollo de software.',
      expertise: [
        'Inteligencia Artificial',
        'Biometría',
        'Estrategia Empresarial',
        'Liderazgo Tecnológico'
      ],
      linkedin: '#',
    },
    {
      name: 'Marco García',
      role: 'CTO & Co-founder',
      photo: mga, // Ruta a la foto
      bio: 'Arquitecto de software con expertise en sistemas escalables y desarrollo de plataformas SaaS de alto rendimiento.',
      expertise: [
        'Arquitectura de Software',
        'Sistemas Escalables',
        'Plataformas SaaS',
        'DevOps & Cloud'
      ],
      linkedin: '#',
    },
    {
      name: 'Yudy Vivas',
      role: 'Customer Success Manager',
      photo: yv, // Ruta a la foto
      bio: 'Experta en experiencia de cliente y gestión de relaciones a largo plazo con enfoque en satisfacción y retención.',
      expertise: [
        'Customer Success',
        'Experiencia de Cliente',
        'Account Management',
        'Retención de Clientes'
      ],
      linkedin: '#',
      email: 'yudyvivas@myntar.io'
    }
  ];

  return (
    <section className="team-section" id="nosotros">
      <div className="team-hero">
        <div className="section-tag">Quiénes Somos</div>
        <h1 className="team-hero-title">
          <span>El Equipo Detrás</span>
          <span className="gradient-text">de la Innovación</span>
        </h1>
        <p className="team-hero-description">
          Un equipo diverso y experimentado que combina expertise técnica, visión comercial 
          y pasión por la innovación para transformar la atención al cliente con IA.
        </p>
      </div>

      <div className="team-stats">
        <div className="team-stat-card">
          <div className="team-stat-value">19+</div>
          <div className="team-stat-label">Años de Experiencia</div>
        </div>
        <div className="team-stat-card">
          <div className="team-stat-value">4</div>
          <div className="team-stat-label">Socios Fundadores</div>
        </div>
        <div className="team-stat-card">
          <div className="team-stat-value">100%</div>
          <div className="team-stat-label">Comprometidos</div>
        </div>
        <div className="team-stat-card">
          <div className="team-stat-value">∞</div>
          <div className="team-stat-label">Potencial</div>
        </div>
      </div>

      <div className="founders-grid">
        {founders.map((founder, index) => (
          <div key={index} className="founder-card">
            <div className="founder-avatar-container">
              <div className="founder-avatar">
                <img 
                  src={founder.photo} 
                  alt={founder.name}
                  onError={(e) => {
                    // Fallback a un placeholder si la imagen no se carga
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(founder.name)}&size=200&background=4B39B5&color=fff&bold=true`;
                  }}
                />
              </div>
            </div>
            <div className="founder-info">
              <h3 className="founder-name">{founder.name}</h3>
              <p className="founder-role">{founder.role}</p>
              <p className="founder-bio">{founder.bio}</p>
              
              <div className="founder-expertise">
                <h4>Áreas de Expertise</h4>
                <div className="expertise-tags">
                  {founder.expertise.map((skill, idx) => (
                    <span key={idx} className="expertise-tag">{skill}</span>
                  ))}
                </div>
              </div>

              <div className="founder-contact">
                {founder.email && <a href={`mailto:${founder.email}`} className="contact-link">
                  <span>📧</span> {founder.email}
                </a>}
                {founder.linkedin && <a href={founder.linkedin} className="contact-link">
                  <span>💼</span> LinkedIn
                </a>}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="team-values">
        <div className="section-header">
          <h2 className="section-title">Nuestros Valores</h2>
          <p className="section-subtitle">
            Los principios que guían nuestro trabajo y definen nuestra cultura empresarial.
          </p>
        </div>
        <div className="values-grid">
          <div className="value-card">
            <span className="value-icon">🚀</span>
            <h3>Innovación Continua</h3>
            <p>Nunca dejamos de evolucionar y mejorar nuestras soluciones.</p>
          </div>
          <div className="value-card">
            <span className="value-icon">🤝</span>
            <h3>Compromiso con el Cliente</h3>
            <p>El éxito de nuestros clientes es nuestro éxito.</p>
          </div>
          <div className="value-card">
            <span className="value-icon">🔒</span>
            <h3>Ética y Transparencia</h3>
            <p>Operamos con los más altos estándares de integridad.</p>
          </div>
          <div className="value-card">
            <span className="value-icon">🌍</span>
            <h3>Impacto Sostenible</h3>
            <p>Construimos soluciones que perduran en el tiempo.</p>
          </div>
        </div>
      </div>

      <div className="team-cta">
        <h2>¿Quieres Unirte al Equipo?</h2>
        <p>Estamos buscando talento excepcional para expandir nuestra visión.</p>
        <button className="btn btn-primary" onClick={() => window.location.href = 'mailto:contact@myntar.io'}>
          Envíanos tu CV
        </button>
      </div>
    </section>
  );
};

export default Team;
